import { CheckItem } from '@rpe/registro-personas-empresas-lib';
import { TipoSubActividad } from '../entity-tipos-sub-actividad/tipos-sub-actividad.model';

export interface RegistroActividadAcreditacionItemFormInput {
  poseeActividad: boolean; //indica si el usuario eligio el tipo de actividad
  actividadDependencia: string; //indica el string del tipo de actividad que depende, produccion etc
  tipoSubActividad: TipoSubActividad;
  listaEspeciesDelTipo: CheckItem[]; //contiene la lista de especies que surgen del tipo
  seleccionada: boolean;
}

export interface RegistroActividadAcreditacionFormInput {
  actividad_id: number;
  listaRegActAcr: RegistroActividadAcreditacionItemFormInput[];
}

export function createEmptyRegistroActividadAcreditacionFormInput(): RegistroActividadAcreditacionFormInput {
  return {
    actividad_id: null,
    listaRegActAcr: []
  };
}
